export function joinClasses(...args: string[]){
    return args.join(" ")
}